import Marquee3k from 'marquee3000'

export default class MarqueeSlider {
    constructor(element) {
        this.selector = element;

        this.initSlider();
    }

    initSlider() {
        const target = this.selector.querySelector('[data-slider]');

        if (!target) {
            return;
        }

        Marquee3k.init({
            selector: `${this.selector.id}-marquee3k`
        });
    }
}